import React from 'react';
import { Checkbox } from '@blueprintjs/core';
import { ShowIf } from 'components/utils';

class ShowIfCheck extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      checked: this.props.checked
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.checked
    })
  }

  onChange(e) {
    this.props.onChange(!this.state.checked)
  }

  render() {
    return(
      <div className={this.props.className}>
        <div className="col-100 no-gutter mb10 mt5">
          <Checkbox className="pt-large" checked={this.state.checked} onChange={this.onChange.bind(this)} name={this.props.name}>
            <span className={this.props.titleClass}>{this.props.label}</span>
          </Checkbox>
        </div>
        <ShowIf condition={this.state.checked}>
          {this.props.children}
        </ShowIf>
      </div>
    )
  }
}

ShowIfCheck.defaultProps = {
  titleClass: 'name-checkbox',
  checked: false,
  className: '',
  name:''
}

export default ShowIfCheck;



// WEBPACK FOOTER //
// ./src/components/utils/ShowIfCheck.jsx